module.exports = __webpack_public_path__ + "img/kg.b835c7f.svg";